import { useState } from "react";

import "react-toastify/dist/ReactToastify.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import { displayDate } from "../../../../utils/masks";
import api from "../../../../services/api";
import { TablePage } from "../../../../containers";
import JobSkipAdd from "../job-skip-add/JobSkipAdd";
import DialogConfirm from "../../../../components/DialogConfirm";
import JobSkip from "../../../../models/JobSkip";
import toastOptions from "../../../../utils/toastOptions";
import { toast } from "react-toastify";
import moment from "../../../../utils/momentConfig";

export default function JobSkipList() {
  const [refresh, setRefresh] = useState<boolean>();
  const [total, setTotal] = useState(0);
  const [pageNo, setPageNo] = useState<number>(1);
  const [isAdd, setAdd] = useState<boolean>(false);
  const [isDialogDelete, setDialogDelete] = useState<boolean>(false);
  const [dialogDeleteText, setDialogDeleteText] = useState<string[]>([]);
  const [jobToDelete, setJobToDelete] = useState<JobSkip>();
  const [ixDeleting, setIxDeleting] = useState<number>(-1);

  const columns = [
    {
      name: "Detalhes",
      sortable: true,
      grow: 2,
      cell: (row: any) => <div className="uk-flex uk-flex-column uk-flex-left">
        <span>{displayDate(row.date)} Pular {row.typeJob} pelo motivo {row.description.toUpperCase()}</span>
        <span className="uk-text-meta uk-text-italic">({moment(row.date).format('dddd')})</span>
      </div>
    },
    {
      name: 'Ações',
      button: true,
      sortable: false,
      cell: (row: any) => (
        <div className='uk-flex uk-flex-between'>
          {moment(row.date).isSameOrAfter(moment(), 'day') ? (
            <a href="#" uk-tooltip="title: Remover" 
              className='uk-margin-small-right' 
              onClick={(ev) => { ev.preventDefault(); handleDelete(row)}}
            >
              {ixDeleting === row.id ? <div uk-spinner="true; ratio:0.5"></div> : <FontAwesomeIcon icon={faTrash} />}
            </a>
          ) : '-'}
        </div>                    
      )
    }
  ];

  const fetch = async (page: number, limit: number) => {
    try {
      setTotal(0);

      let orderParams = {
        page: page,
        limit: limit
      } as any;

      const response = await api.get(`jobs/skip`, {
        params: orderParams
      });

      setTotal(response.data.total);

      setPageNo(page);

      return response;
    } catch (e: any) {
      e.messages?.forEach((m: string) => {
        toast.error(m, toastOptions);
      });
      return { data: [], total: 0 };
    }
  };

  const handleDelete = (row: any) => {
    setDialogDeleteText([`Tem certeza que deseja remover a configuração de pular o job do dia ${displayDate(row.date)}?`]);
    setDialogDelete(true);
    setJobToDelete(row);
  }

  const dialogClose = () => {
    setDialogDelete(false);
    setDialogDeleteText([]);
    setJobToDelete(undefined);
    setIxDeleting(-1);
  };

  const confirmDeletion = async (confirmationCode: string) => {
    try {
      await api.delete(`jobs/skip/${jobToDelete?.id}`);
      setDialogDelete(false);
      toast.success("Configuração de pular job removida com sucesso!", toastOptions);
      setRefresh(!refresh);
      dialogClose();
    } catch (e: any) {
      e.messages?.forEach((m: string) => {
        toast.error(m, toastOptions);
      });
    }
  };

  return (<>
    <TablePage 
      title={"Configurações de Jobs"}
      columns={columns}
      fetch={fetch}
      refresh={refresh}
      showSubHeader
      totalRecords={total}
      labelTotalRecords={`${total} ${total === 1 ? "Configurado" : "Configurados"}`}
      backUrl={`/`}
      messageEmpty={<span>Nenhuma <b>configuração</b> encontrada!</span>}
      showAddButton
      handleAdd={() => {setAdd(true);}}
    />
    <JobSkipAdd
      open={isAdd}
      afterHandleSubmit={() => {
        setAdd(false);
        setRefresh(!refresh);
      }}
      afterCloseModal={() => setAdd(false)}
    />
    <DialogConfirm 
      open={isDialogDelete}
      text={dialogDeleteText}
      afterClose={dialogClose}
      handleConfirmation={(confirmationCode) =>
        confirmDeletion(confirmationCode)
      }
    />
  </>);
}